import client from 'api/client'

export const fetchVersions = (id, locale) =>
  client().get(`/collections/v2/${id}/versions`, {locale})
